/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import {
  Toast as RadialToast,
  TOAST_VISIBILITY_DURATIONS,
  TOAST_VARIANTS
} from 'cdk-radial';
import { ToastProps } from './types';

export const Toast = ({
  id = 'radial-toast',
  buttonProps,
  status = TOAST_VARIANTS.NEGATIVE,
  duration = TOAST_VISIBILITY_DURATIONS.INFINITE,
  content
}: ToastProps): React.JSX.Element => (
  <>
    <RadialToast
      actions={buttonProps}
      content={content}
      id={id}
      variant={status}
      visibilityDuration={duration}
    />
  </>
);
